import polsatGamesLowRes from 'assets/youtube-media/polsat-games.webp';
import zewCthulhuLowRes from 'assets/youtube-media/call-of-cthulhu.webp';
import pyrkonLowRes from 'assets/youtube-media/pyrkon-studio.webp';
import womenLeadershipLowRes from 'assets/youtube-media/women-leadership-in-gamedev.webp';
import toJaGoTneLowRes from 'assets/youtube-media/to-ja-go-tne.webp';
import digitalDragonsCharacterCreationLowRes from 'assets/youtube-media/digital-dragons-academy.webp';
import digitalDragonsLectureLowRes from 'assets/youtube-media/digital-dragons-academy-lecture.webp';
import digitalDragonsNarrativeDesignLowRes from 'assets/youtube-media/digital-dragons-academy-narrative-design.webp';
import nutkaWNutke from 'assets/youtube-media/nutka-w-nutke.webp';

export const mediaVideos = [
  {
    id: 1,
    LowQualityImage: polsatGamesLowRes,
    HighQualityImage: 'maxresdefault',
    embedID: '5uRJ9TySKPo',
    start: 1574,
    title: '„Faux Pas”, Polsat Games – an interview on narrative design',
    alt: '„Faux Pas”, Polsat Games – an interview on narrative design',
  },
  {
    id: 2,
    LowQualityImage: zewCthulhuLowRes,
    HighQualityImage: '0',
    embedID: '0h99w0r07Z0',
    start: 0,
    title: 'Call of Cthulhu 7ed. trailer',
    alt: 'Call of Cthulhu 7ed. trailer',
  },
  {
    id: 3,
    LowQualityImage: pyrkonLowRes,
    HighQualityImage: 'maxresdefault',
    embedID: 'xe_pOPZvkNo',
    start: 0,
    title: 'Pyrkon Studio – a series of interviews',
    alt: 'Pyrkon Studio – a series of interviews',
  },
  {
    id: 4,
    LowQualityImage: womenLeadershipLowRes,
    HighQualityImage: 'maxresdefault',
    embedID: 'eFm_O8JqBIc',
    start: 2227,
    title: 'Digital Dragons 2022 - women leadership panel',
    alt: 'Digital Dragons 2022 - women leadership panel',
  },
  {
    id: 5,
    LowQualityImage: toJaGoTneLowRes,
    HighQualityImage: 'maxresdefault',
    embedID: 'Q70rDHeYDoo',
    start: 55,
    title: '“To Ja Go Tnę” – an interview on Call of Cthulhu 7ed',
    alt: '“To Ja Go Tnę” – an interview on Call of Cthulhu 7ed',
  },
  {
    id: 6,
    LowQualityImage: digitalDragonsCharacterCreationLowRes,
    HighQualityImage: 'maxresdefault',
    embedID: 'FxJZXmhbWxY',
    start: 6,
    title: 'Digital Dragons Academy – my lecture on character creation',
    alt: 'Digital Dragons Academy – my lecture on character creation',
  },
  {
    id: 7,
    LowQualityImage: digitalDragonsLectureLowRes,
    HighQualityImage: 'maxresdefault',
    embedID: '7pCrTI5mID4',
    start: 0,
    title: 'Digital Dragons - Academy lecture',
    alt: 'Digital Dragons - Academy lecture',
  },
  {
    id: 8,
    LowQualityImage: digitalDragonsNarrativeDesignLowRes,
    HighQualityImage: 'maxresdefault',
    embedID: 'U6hAvJc_W_E',
    title: 'Digital Dragons – speech on narrative design',
    alt: 'Digital Dragons – speech on narrative design',
  },
  {
    id: 9,
    LowQualityImage: nutkaWNutke,
    HighQualityImage: 'maxresdefault',
    embedID: 'lsbBFXlCvLk',
    title: 'RPG session recorded with Majka Jeżowska',
    alt: 'RPG session recorded with Majka Jeżowska',
  },
];
